<template>
  <div class="zv-page">
    <div class="zv-content">
      <!-- <div class="zv-block" style="display:flex">
        <div class="block" style="margin-left:20px;display:flex">
          <span class="countryName">分类</span>
          <el-input placeholder="输入关键字" v-model="countryName" clearable></el-input>
        </div>

        <div style="margin-left:20px">
          <el-row>
            <el-button type="success" @click="queryData()">查询</el-button>
            <el-button type="primary">导出</el-button>
          </el-row>
        </div>
      </div> -->
      <!-- <el-button type="success" style="margin:10px 0" @click="addResponseLibraryData()">新增条目</el-button> -->
      <div class="new_form" style="width: 300px">
        <el-form
          ref="myForm"
          label-width="100px"
          :model="formData"
          :rules="formRules"
        >
          <el-form-item label="分类名称：" prop="category_name">
            <el-input v-model="formData.category_name" placeholder="请输入分类名称" clearable></el-input>
          </el-form-item>

          <el-form-item label="父级分类：" >
            <el-select v-model="formData.parent_id" @change="categoryChange" placeholder="请选择">
              <el-option
                label="顶级分类"
                :value="0"
              ></el-option>
              <el-option
                v-for="item in categoryList"
                v-if="item.level != 3"
                :key="item.id"
                :label="item.level+'-'+item.category_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

        </el-form>
      </div>
      <div class="category_tabs">
        <span :class="tabsIndex == 1 ? 'tabs_active':''" @click="tabFn(1)">已选字段</span>
        <span :class="tabsIndex == 2 ? 'tabs_active':''" @click="tabFn(2)">新增字段</span>
      </div>
      <div v-if="tabsIndex == 1">
        <el-table
          :data="tableData"
          style="width: 100%;margin-top: 10px"
        >
          <el-table-column prop="id" label="序号">
            <template slot-scope="scope">
              <span>{{scope.$index + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="field_name" label="字段名称"></el-table-column>
          <el-table-column prop="notnll" label="是否必填">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.notnll"
                >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="enable" label="启用状态">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.enable"
                >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="update_time" label="关联">
            <template slot-scope="scope">
            
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="toTop(scope.$index)">
                置顶
              </el-button>
              <el-button type="text" @click="upTr(scope.$index)" size="small">
                向上
              </el-button>
              <el-button type="text" @click="downTr(scope.$index)" size="small">
                向下
              </el-button>
              <el-button type="text" @click="toBottom(scope.$index)" size="small">
                置底
              </el-button>
              <el-button type="text" @click="rowTableDel(scope.row)" size="small">
                删除
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="last_admin_username" label="输入说明">
            <template slot-scope="scope">
              <el-input v-model="scope.row.inputhit"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-table
        ref="allTable"
        :data="allTableData"
        v-if="tabsIndex == 2"
        style="width: 100%;margin-top: 10px"
      >
        <el-table-column prop="field_name" label="字段名称"></el-table-column>
        <el-table-column prop="field_type" label="字段形式"></el-table-column>
        <el-table-column label="形式说明">
          <template slot-scope="scope">
            <span>{{scope.row.field_length == 0 ? scope.row.field_config_data == null ?'不限':scope.row.field_config_data.multi_select == true ? '多选':'单选':'字符限制'+scope.row.field_length+'字'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="notnll" label="是否必填">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.notnll"
              >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="enable" label="启用状态">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.enable"
              >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200px">
          <template slot-scope="scope">
            <el-button type="text" style="color: red" @click="tableDel(scope.row)" v-if="scope.row.btns" size="small">
              删除
            </el-button>
            <el-button type="text" @click="tableAdd(scope.row)" v-if="!scope.row.btns" size="small">
              选用
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="footer_btn" style="margin-top: 30px">
        <el-button type="primary" @click="submitFn">提交分类</el-button>
        <el-button type="primary" @click="submitCategoryFn">提交分类字段</el-button>
        <!-- <el-button @click="go">取消</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
import api from "./api";

export default {
  name: "ResponseLibrary",
  data() {
    return {
      addressSelectData: null,
      addressItem: null,
      countryName: "",
      tableData: [],
      allTableData: [],
      currentPage: 1,
      totalList: null,
      formData: {
        parent_id: this.$route.query.name? "":Number(this.$route.query.editId) || "",
        category_name: this.$route.query.name == 'false' ? "":this.$route.query.name
      },
      formRules: {
        category_name: [{
          required: true,
          message: "分类名字不能为空",
          trigger: "blur"
        }]
      },
      categoryList: '',
      tabsIndex: 1
    };
  },
  created() {
    this.getData();
    if(this.$route.query.editId != 'false' && this.$route.query.add == '0') {
      this.dataInfo()
    }else {
      if(this.$route.query.parent_id != 'false') {
        this.formData.parent_id = Number(this.$route.query.parent_id)
        this.categoryChange(this.formData.parent_id)
      }
    }
    
  },
  methods: {
    // info
    dataInfo() {
      let datas = {
        id: this.$route.query.editId
      }
      api
        .categoryInfo(datas)
        .then(res => {
          this.formData.parent_id = res.info.parent_id
          this.tableData = res.info.field_config || []
        })
        .catch(err => {
        });
    },

    // tabs 切换
    tabFn(index) {
      this.tabsIndex = index
      if(index == 1) {

      }else {
        this.categoryAll()
      }
    },
    // 获取数据
    getData() {
      api
        .categoryList()
        .then(res => {
          this.categoryList = res.list;
        })
        .catch(err => {
        });
    },
    categoryChange(val) {
       api
        .categoryInfoList({id: val})
        .then(res => {
          this.tableData = res.info.field_config
        })
        .catch(err => {
        });
    },
    categoryAll() {
      api
        .fieldConfigList()
        .then(res => {
          this.allTableData = res.list;
          this.allTableData.map((item,index)=> {
            this.tableData.map(items => {
              if(items.field_id == item.id) {
                this.$set(item,"btns",true)
              }
            })
          })
        })
        .catch(err => {
        });
    },
    tableDel(rows) {
      this.$set(rows,"btns",false)
      let newTable = this.tableData.filter(item=> {
        return item.field_id != rows.id
      })
      this.tableData = newTable
    },
    tableAdd(rows) {
      this.$set(rows,"btns",true)
      let datas = {
        backup_data_field: "",
        enable: rows.enable || false,
        field_config_data: rows.field_config_data,
        field_id: rows.id,
        field_length: rows.field_length,
        field_name: rows.field_name,
        field_type: rows.field_type,
        inputhit: "",
        notnll: rows.notnll || false
      }
      this.tableData.push(datas)
    },
    // rows 操作（置顶、下移、上移、置底、删除）
    rowTableDel(rows) {
      let newTable = this.tableData.filter(item=> {
        return item.field_id != rows.field_id
      })
      this.tableData = newTable
    },
    // 公共函数封装
    swapItems(arr, index1, index2,direction) {
      if(direction == "up"){//置顶
        arr.unshift(arr[index1]);
        arr.splice(index1+1,1);
        return arr;
      }
      if(direction == "down"){//置底
        arr.push(arr[index1]);
        arr.splice(index1,1);
        return arr;
      }
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
      return arr;
    },
    toTop(index) {
      this.swapItems(this.tableData,index,this.tableData.length,"up")
    },
    toBottom(index) {
      this.swapItems(this.tableData,index,this.tableData.length,"down")
    },
    upTr(index) { // 上移
      if (index === 0) {
        return
      }
      this.swapItems(this.tableData, index, index - 1);
    },
    downTr(index) { // 下移
      if (index === this.tableData.length - 1) {
        return
      }
      this.swapItems(this.tableData, index, index + 1);
    },

    submitFn() {
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          if(this.$route.query.name != "false") {
            let datas = this.formData
            datas.id = Number(this.$route.query.editId)
            api
            .categoryEdit(datas)
            .then(res => {
              this.$message({
                message: "修改分类成功！",
                type: "success"
              })
              setTimeout(()=> {
                this.$router.go(-1)
              },2000)
            })
            .catch(err => {
            });
          }else {
            api
            .categoryAdd(this.formData)
            .then(res => {
              this.$message({
                message: "提交分类成功！",
                type: "success"
              })
              setTimeout(()=> {
                this.$router.go(-1)
              },2000)
            })
            .catch(err => {
            });
          }
        }
      })
    },
    submitCategoryFn() {
      console.log(this.formData)
      if(this.formData.parent_id == undefined) {
        this.$message({
          message: "请选择分级分类",
          type: "error"
        })
      }else {
        let datas = {
          id: this.$route.query.editId,
          field_config: JSON.stringify(this.tableData)
        }
        api
          .fieldConfigSet(datas)
          .then(res => {
            this.$message({
              message: "提交分类字段成功！",
              type: "success"
            })
            setTimeout(()=> {
              this.$router.go(-1)
            },2000)
          })
          .catch(err => {
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.category_tabs {
  span {
    font-size: 14px;
    padding-left: 20px;
    cursor: pointer;
  }
  .tabs_active {
    color: #3ae2c4;
  }
}
.countryName {
  margin-right: 10px;
  width: 40px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>